import { Modal} from 'antd';
import Aichat from '../../../styles/images/assistnew.svg';
import Styles from './scss/upgarde.module.scss'
import Upgrade from '../../../styles/images/upgradepop.svg';
import { GetItemFromStorage } from '../../../custom_hooks/useStorage';
import { LocalStorage } from '../../../custom_hooks/localStorageKeys';
import { navigateToTicketing } from '../../../base/utils';


function Aiupgrade({ type, onOk }: any) {

  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);

  const close = () =>{
      if(onOk) onOk()
  }

  const open =()=>{
      navigateToTicketing()
  }

  return (
    <>
      <Modal
        title={<span></span>}
        open={true}
        className="customModal  skilldisable upgradeaichat"
        centered
        closeIcon={<span className="icon__Close16" ></span>}
        footer={false}
        onCancel={close}
      >
        <div className={Styles.upgradeimg}>
          {type === 'Agent Assist' ? <img src={Aichat} alt='' /> : <img src={Upgrade} alt='' />}
        </div>

        {loginUserCcaasDetail?.roleid == 3
          ? <div className={Styles.growthplan}>
            <h3>{`Upgrade Your Plan and Unlock the ${type}`}</h3>
            {/* <button onClick={open}>Upgrade</button> */}
          </div>
          : <div className={Styles.growthplan}>
            <h3>{`Upgrade Required: Please contact your administrator to upgrade your plan and enable this feature`}</h3>
            <button onClick={close}>Close</button>
          </div>}
          
      </Modal>
    </>
  );
}
export default Aiupgrade;